import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "clear"];

  connect() {
    this.updateClearButton();
  }

  handleInput() {
    this.updateClearButton();
  }

  updateClearButton() {
    const clearButton = this.element.querySelector("[data-search-target=\"clear\"]");
    if (clearButton) {
      if (this.inputTarget.value.trim() === "") {
        clearButton.classList.add("hidden");
      } else {
        clearButton.classList.remove("hidden");
      }
    }
  }

  clear() {
    this.inputTarget.value = "";
    this.updateClearButton();
    // Submit the form to clear search results
    this.element.closest("form").submit();
  }
}
